module.exports = __webpack_public_path__ + "static/media/445GriffinStNW_2018-06-05_33.5223df3d.jpg";